import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash-es';
import { updateNotificationSettings, getNotificationSettings } from '../api';
import { SET_SETTINGS } from '../actions';
import { Button, Card, ButtonGroup, SliderCheckbox, Layout, StatusMessage, TitleBar } from '../components/library-components';
import validate from 'validate.js';

import '../../stylesheets/components/react-tagsinput.scss';
import '../../stylesheets/pages/email-configurations.scss';

export class CustomerEmailNotifications extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showNotification: { isNotificationOpen: false, status: '', statusMessage: '' },
      inputProps: {
        placeholder: 'Enter an email address'
      },
      isSaveDisabled: true,
      errors: {}
    };
    this.handleValueChange = this.handleValueChange.bind(this);
  }

  render () {
    return (
      <Layout>
        <TitleBar title='Customer Email Notifications' breadcrumbTitle='Home' breadcrumbPath='/' />
        <Card title='Subscriber Email Settings'>
          <SliderCheckbox label='Subscription Creation'
            id='subscription_creation'
            name='subscription_creation'
            enabled={_.get(this.props.settings, 'subscription_creation', false)}
            onChange={(event) => this.handleValueChange('subscription_creation', event.target.checked)} />
          <div className='form-row'>
            <SliderCheckbox label='Subscription Renewal Reminder'
              id='renewal_reminder_switch'
              name='renewal_reminder'
              enabled={_.get(this.props.settings, 'renewal_reminder', false)}
              onChange={(event) => this.handleValueChange('renewal_reminder', event.target.checked)} />

            { _.get(this.props.settings, 'renewal_reminder', false) && (<div>
              <span className='label email-configurations__renewal-days-before-expiry'>Days before expiry</span>
              <input type='number' id='renewal_reminder_due_days' name='renewal_reminder_due_days'
                min='1' max='30' onKeyDown={event => (event.which === 13 ? event.preventDefault() : null)}
                value={_.get(this.props.settings, 'renewal_reminder_due_days', 1)}
                onChange={(e) => this.handleReminderDueDays(e.target.value)}
              />
              <p className='error-msg'>{this.state.errors.renewal_reminder_due_days}</p>
            </div>)
            }
          </div>
        </Card>

        <ButtonGroup>
          <Button disabled={this.state.isSaveDisabled} onClick={(e) => this.updateAccountEmailSettings()} primary>Save</Button>
        </ButtonGroup>

        {this.state.showNotification.isNotificationOpen &&
        <StatusMessage statusMessage={this.state.showNotification.statusMessage}
          status={this.state.showNotification.status}
          onCancel={() => this.setState({ showNotification: { isNotificationOpen: false, status: '', statusMessage: '' } })} />}
      </Layout>
    );
  }

  updateErrors (key, value) {
    const errors = this.state.errors;
    errors[key] = value;
    const hasErrors = _.keys(errors).some(key => errors[key] != null);
    this.setState({ errors, isSaveDisabled: hasErrors });
  }

  handleReminderDueDays (value) {
    this.handleValueChange('renewal_reminder_due_days', value);

    const constraints = {
      renewal_reminder_due_days: {
        presence: true,
        numericality: {
          onlyInteger: true,
          greaterThan: 0,
          lessThanOrEqualTo: 30
        }
      }
    };
    if (!_.isNil(validate({ renewal_reminder_due_days: value }, constraints))) {
      this.updateErrors('renewal_reminder_due_days', 'Value must be a number between 1 and 30');
    }
  }

  handleValueChange (key, value) {
    const notificationSettings = Object.assign(this.props.settings, { [key]: value });
    this.props.setSettings(notificationSettings);
    this.updateErrors(key, null);
  }

  updateAccountEmailSettings () {
    updateNotificationSettings(this.props.settings)
      .then((response) => {
        this.setState({ showNotification: { isNotificationOpen: true, status: 'success', statusMessage: 'Email settings saved Successfully!' } });
        this.setState({ error: '', isSaveDisabled: true });
      },
      (errors) => { this.setState({ showNotification: { isNotificationOpen: true, status: 'error', statusMessage: errors.message } }); });
  }

  componentDidMount () {
    getNotificationSettings().then((response) => {
      if (response) {
        this.props.setSettings(response);
      }
    });
  }
}

function mapStateToProps (state) {
  return {
    settings: state.settings || []
  };
}

function mapDispatchToProps (dispatch) {
  return {
    setSettings: (settings) => dispatch({ type: SET_SETTINGS, settings: settings })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerEmailNotifications);
